/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { GUARANTEE_SECTION } from 'pricing-pages-unified-ui/constants/Breakpoints';
import globalNavHeight from 'nav-meta/global-nav-height';
const Positioning = styled.div.withConfig({
  displayName: "GuaranteeBlob__Positioning",
  componentId: "sc-1mmtwyb-0"
})(["position:absolute;z-index:-1;top:", ";@media (max-width:", "px){display:none;}"], `-${globalNavHeight}`, GUARANTEE_SECTION);
export default (() => /*#__PURE__*/_jsx(Positioning, {
  children: /*#__PURE__*/_jsx("svg", {
    width: "1000px",
    viewBox: "0 0 1372 613",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fill: "#F5F8FA",
      transform: "translate(-68.000000, -37.000000)",
      d: "M214.505639,89.27689 C495.098924,-14.8441387 1134.236,49.2342449 1329.70379,170.419485 C1525.17157,291.604725 1453.47233,483.500647 1172.87905,587.621676 C892.285765,691.742705 532.48833,661.062589 319.055466,528.739439 C105.622602,396.416289 -66.087645,193.397919 214.505639,89.27689 Z",
      id: "bg-blob"
    })
  })
}));